module.exports = __webpack_public_path__ + "assets/img/ph_d_3.fa90e5de.jpg";